import 'isotope-layout/dist/isotope.pkgd.min';
import 'imagesloaded/imagesloaded.pkgd.min';

export default function () {
  function isotopInit(el) {
    const grid = $(el).isotope({
      itemSelector: '.grid__item',
      percentPosition: true,
    });
    grid.imagesLoaded().progress(() => {
      grid.isotope('layout');
    });
    return grid;
  }

  function gridIsotopInit() {
    const $grids = $('[data-type="column-grid"]');
    if (!$grids.length) return;

    $grids.each((i, el) => {
      isotopInit(el);
    });
  }

  function isotopWithFiltersInit() {
    const $gridWithFilters = $('[data-type="column-grid-filter"]');
    if (!$gridWithFilters.length) return;

    const isoGrid = isotopInit($gridWithFilters);
    const $filters = $('[data-type="filter"]');
    $filters.each((i, filter) => {
      const $this = $(filter);
      $this.on('click', function () {
        let filterValue = '';
        const $filtersContainer = $this.closest('[data-type="filters"]');

        $this.toggleClass('selected');

        if ($filtersContainer.length) {
          $('.selected').each((k, select) => {
            filterValue += $(select).data('filter');
          });
          if (~filterValue.indexOf('*')) {
            filterValue = '*';
          }
        } else {
          filterValue = $(this).data('filter');
        }
        isoGrid.isotope({ filter: filterValue });
      });
    });
  }

  gridIsotopInit();
  isotopWithFiltersInit();
}




// WEBPACK FOOTER //
// ./scripts/elements/isotop-grid.js